import { DrawerBody } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import LabeledValue, {
  LabeledValueContextProvider,
} from "components/Shared/LabeledValue";
import TagList from "components/Shared/TagList";
import NamingOptions from "components/Products/NamingOptions";
import QuantityPriceVariantsTable from "components/Products/ProductLinePanel/QuantityPriceVariantsTable";

const viewFragment = gql(/* GraphQL */ `
  fragment ProductLineView on ProductLine {
    id
    name
    shortName
    nameSeparator
    isInternalSkuIdAppended
    shipsFromZip
    productLineCategoryDepartmentSubDepartmentsList(orderBy: CREATED_AT_ASC) {
      id
      productCategoryDepartmentSubDepartment {
        id
        qualifiedLabel
      }
    }
    ...ProductLineQuantityPriceVariantsTable
  }
`);

type Props = {
  productLine: FragmentType<typeof viewFragment> | null | undefined;
  isLoading?: boolean;
};

export default function ProductLinePanelView({
  productLine: productLineFragment,
  isLoading,
}: Props) {
  const productLine = getFragmentData(viewFragment, productLineFragment);

  return (
    <DrawerBody pb={10}>
      <LabeledValueContextProvider isLoading={isLoading}>
        <NamingOptions
          heading="Name Formats"
          productLineName={productLine?.name}
          productLineShortName={productLine?.shortName}
          skuName={undefined}
          nameSeparator={productLine?.nameSeparator}
          isInternalSkuIdAppended={productLine?.isInternalSkuIdAppended}
          isLoading={isLoading}
        />

        <LabeledValue
          label="Product Categories"
          value={
            productLine?.productLineCategoryDepartmentSubDepartmentsList
              ?.length ? (
              <TagList
                items={
                  productLine?.productLineCategoryDepartmentSubDepartmentsList
                }
                getKey={(c) => c.id}
                getLabel={(c) =>
                  c.productCategoryDepartmentSubDepartment?.qualifiedLabel
                }
                variant="outline"
              />
            ) : undefined
          }
        />

        <LabeledValue
          label="Ships From ZIP"
          value={productLine?.shipsFromZip}
        />
      </LabeledValueContextProvider>

      <QuantityPriceVariantsTable productLine={productLine} />
    </DrawerBody>
  );
}
